import global from './global.module.css'
export default global
